import React, { useMemo } from 'react';
import { FileEntityType } from '../../../../../types/file';
import FileViewLoader from '../FileViewLoader';
import ImageView from './ImageView';

interface ProfileImageViewLoader {
  fileId?: string;
  className?: string;
  placeholder?: boolean | React.ReactNode;
}

export default function ProfileImage({ fileId, className, placeholder = true }: ProfileImageViewLoader) {
  const fallback = useMemo(() => {
    return <ImageView className={className} url={`${process.env.REACT_APP_STORAGE_URL}/ventory/Profile.svg`} />;
  }, [className]);

  if (!fileId) {
    if (!placeholder) return null;
    return typeof placeholder === 'boolean' ? fallback : (placeholder as React.JSX.Element);
  }

  return (
    <FileViewLoader fileId={fileId} className={className} fileEntityType={FileEntityType.user} fallback={fallback} />
  );
}
